<template lang="pug">
div
  buttonArea
  .conbox
    .tabbox
      .panelbox
        .panel-holder
          template(v-if="streamUrl !==null")
            .resbox.livestream
              .live
                iframe(width='100%' height='100%' :src="streamUrl" title='video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowfullscreen)
            //- .live-tnc
              button.btn-submit(type='submit' data-bs-toggle='modal' data-bs-target='#tnc') Terms &amp; Conditions
          template(v-else)
            .text-center.text-white.my-4
              i.fa-regular.fa-newspaper.display-6
              div No data
  slots
</template>
<script>
import config from "@/config";
import slots from "@/views/default/_slot.vue"
import buttonArea from "@/component/_buttonArea.vue"
export default {
  components:{
    slots,
    buttonArea
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      loading:false,
      // socialList: [],
      streamUrl: "",
      showButton: false
    }
  },
  computed:{
  },
  created(){
    this.getSeo("livestream")
  },
  mounted(){
    this.getStreamLink()
    // this.getIp()
  },
  methods:{
    getIp(){
      this.$http.get("https://api.ipify88.com/").then(
        successResponse => {
          if(successResponse){
            console.log(successResponse.data)
          }else{
          }
        },
        errorResponse => {
          this.pageLoading = false
        }
      );
    },
    getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            if(response.data.length > 0){
              // this.$store.dispatch("user/seoInfo", response.data[0])
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    getStreamLink(){
      this.$store
        .dispatch("user/getStreamLink", { })
        .then(response => {
          if (response.success == true) {
            this.streamUrl = response.data[0].iframe_url
          } else {             
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          }
        })
        .catch(response => {
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
          }
        });
    },
  }
}
</script>
<style lang="scss" scoped>
.show-mobile{
  display: none !important;
  @media(max-width: 680px){
    display: flex !important;
  }
}
</style>